import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { ThemeProvider } from '@pets-ui/ThemeProvider/ThemeProvider'
import { VStack } from '@pets-ui/VStack/VStack'
import { useMemo } from 'react'
import { FpB2bProductCatalogProvider } from '../../fp-b2b-shared/components/ProductCatalogProvider/ProductCatalogProvider'
import { colorThemeMap, fastpassColorTheme } from '../constants'
import { useResetBrandOnEntry, useStmBrandStore } from '../hooks'
import { BrandNewProductSection } from './components/BrandNewProductSection'
import { NewProductsBanner } from './components/NewProductsBanner'

interface NewProductsProps {
  basePath: string
}

export const NewProducts = (props: NewProductsProps) => {
  const { basePath } = props
  useResetBrandOnEntry()
  const { currentBrand, brands } = useStmBrandStore()

  const visibleBrands = useMemo(() => currentBrand
    ? brands.filter(brand => brand.campaignCode === currentBrand.campaignCode)
    : brands,
  [currentBrand, brands])

  return (
    <VStack gap={4}>
      <NewProductsBanner />
      {visibleBrands.map(brand => (
        <ThemeProvider key={brand.campaignCode} theme={colorThemeMap[brand.projectCode] ?? fastpassColorTheme}>
          <FpB2bProductCatalogProvider
            platform={Platform.STM}
            campaignId={brand.campaignId}
            campaignCode={brand.campaignCode}
            projectCode={brand.projectCode}
            countryCode={brand.countryCode}
          >
            <BrandNewProductSection brand={brand} basePath={basePath} />
          </FpB2bProductCatalogProvider>
        </ThemeProvider>
      ))}
    </VStack>
  )
}
